import FavoriteVoyageStop from "./FavoriteVoyageStop";

export default class FavoriteVoyage {
    id: string = null;
    stops: FavoriteVoyageStop[] = [];
    favoriteVoyageName: string = null;
    shipLength: number = null;
    shipWidth: number = null;
    shipDraught: number = null;
    shipHeight: number = null;
    shipSpeed: number = null;
    shipTonnage: number | null = null;
    recreationalBoating: boolean = null;
    professionalShipping: boolean = null;
    passengerShip: boolean = null;
    loaded: boolean = null;
    adn: boolean = null;
    convoy: boolean = null;
    pusher: boolean = null;
}